var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-simple-table",
    { attrs: { dense: "" } },
    [
      _vm._l(_vm.tables, function (subTable, l) {
        return [
          _c("thead", { key: l + "-title", staticClass: "table-header" }, [
            _c(
              "tr",
              _vm._l(subTable.table.header, function (header, k) {
                return _c(
                  "th",
                  {
                    key: "header-" + k + "-" + header,
                    staticClass: "text-left",
                    style: _vm.headerStyle(k),
                  },
                  [_vm._v(" " + _vm._s(header) + " ")]
                )
              }),
              0
            ),
          ]),
          _c(
            "tbody",
            { key: l + "-body" },
            [
              _vm._l(subTable.table.rows, function (row, i) {
                return _c(
                  "tr",
                  { key: "row-" + i + "-" + l },
                  _vm._l(row, function (col, j) {
                    return _c(
                      "td",
                      {
                        key: "col-" + i + "-" + j,
                        class: {
                          "table-header": _vm.firstColumnHeader && j === 0,
                          "font-weight-bold":
                            subTable.lastRowBold &&
                            i === subTable.rows.length - 1,
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.formattedValue(col, subTable.format)) +
                            " "
                        ),
                      ]
                    )
                  }),
                  0
                )
              }),
              !subTable.table.rows || !subTable.table.rows.length
                ? _c(
                    "tr",
                    [
                      _c("td", [_vm._v("No data")]),
                      _vm._l(subTable.table.header.length - 1, function (i) {
                        return _c("td", { key: "no-data-row-" + i + "-" + l })
                      }),
                    ],
                    2
                  )
                : _vm._e(),
            ],
            2
          ),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }